import TemplateBlock, { TemplateBlockProps } from './TemplateBlock';
import withPresenter from './TemplateBlock.presenter';
import withInteractor from './TemplateBlock.interactor';

export type { TemplateBlockProps };
export default withInteractor(withPresenter(TemplateBlock));
